import { FormattedMessage } from 'react-intl';

import CheckSVG from '@/svg/Check.svg';

export const ShippingInsured = () => {
  return (
    <section className="flex flex-col items-center justify-center gap-3 py-8 border-b border-sky-300 w-full">
      <img src={CheckSVG} alt="check" />
      <h3 className="text-xl">
        <FormattedMessage id="shipping-insured.thank-you" />
      </h3>
      <p className="text-ink-500">
        <FormattedMessage id="shipping-insured.message" />
      </p>
    </section>
  );
};
